export default "__VITE_ASSET__CMR_Cq6p__"